'use client'

import Cookie from 'js-cookie'
import { addBreadcrumb, setUser } from '@sentry/nextjs'
import { captureException, getDomain } from '@sylveraio/react-utils'
import posthog from 'posthog-js'
import { ACCESS_COOKIE, REFRESH_COOKIE, REVALIDATION_COOKIE } from './constants'

export type CookieType = 'refresh' | 'access' | 'revalidation'

const domain = getDomain(true, true)

function clearCookies(cookieType?: CookieType): void {
  addBreadcrumb({
    message: 'Clearing cookies',
    data: {
      cookieType,
    },
  })

  if (cookieType === 'access' || typeof cookieType === 'undefined') {
    try {
      Cookie.remove(ACCESS_COOKIE, {
        domain,
      })
      Cookie.remove(ACCESS_COOKIE)
    } catch (e) {
      captureException(e, 'cookies - access')
    }
  }
  if (cookieType === 'refresh' || typeof cookieType === 'undefined') {
    try {
      Cookie.remove(REFRESH_COOKIE, {
        domain,
      })
      Cookie.remove(REFRESH_COOKIE)
    } catch (e) {
      captureException(e, 'cookies - refresh')
    }
  }
  if (cookieType === 'revalidation' || typeof cookieType === 'undefined') {
    try {
      Cookie.remove(REVALIDATION_COOKIE, {
        domain,
      })
      Cookie.remove(REVALIDATION_COOKIE)
    } catch (e) {
      captureException(e, 'cookies - revalidation')
    }
  }
}

/**
 * Clears cookies, resets Sentry and Posthog states, then calls success or failure functions
 */
export async function signOut(
  onSuccess?: () => void,
  onFailure?: () => void,
): Promise<void> {
  try {
    clearCookies()
    // await Auth.signOut({
    //   global: true,
    // })
    setUser(null)
    if (onSuccess) onSuccess()
    if (process.env['NEXT_PUBLIC_POSTHOG']) posthog.reset()
  } catch (e) {
    captureException(e, 'signOut')
    if (onFailure) onFailure()
  }
}
